/**
 * Iterate through all sequential pairs of an array.
 */

export function* pairwise<T>(iterable: Iterable<T>): Generator<[T, T?]> {
    let last: T = null;
    for (const item of iterable) {
        if (last == null) {
            last = item;
            continue;
        }
        yield [last, item];
        last = item;
    }
}
